import React from 'react';
import { CtaButton } from './CtaButton';
import { checkoutUrl, closingLines, ctaLabels } from '../data/content';
export function Closing() {
  return <section className="w-full bg-ivory py-14 md:py-24" data-id="element-16" data-mp="3t2vkz4ykeyv6">
      <div className="mx-auto w-full max-w-3xl px-5 text-center md:px-8" data-id="element-17" data-mp="3f8bc3go7frrc">
        <h2 className="font-serif text-3xl font-semibold leading-tight text-ink md:text-5xl" data-id="element-18" data-mp="3japvq2zp6vjo">
          Haz de octubre un mes diferente
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-muted md:text-xl" data-id="element-19" data-mp="359lulp0809bm">
          31 días pueden pasar como cualquier otro mes.
        </p>
        <p className="mx-auto mt-3 max-w-xl text-lg leading-relaxed text-ink md:text-xl" data-id="element-20" data-mp="2wb0bnsqu6sab">
          O pueden convertirse en 31 pequeñas oportunidades para detenerte, rezar y volver a hacer
          espacio para Dios.
        </p>

        <ul className="mx-auto mt-10 grid max-w-2xl gap-3 sm:grid-cols-3" data-id="element-21" data-mp="ukghefqy7u1o">
          {closingLines.map(line => <li key={line.label} className="flex items-center justify-center gap-3 rounded-2xl bg-cream px-4 py-4 ring-1 ring-line sm:flex-col sm:gap-2 sm:py-6" data-id="element-22" data-mp="yjxofdm0wz8y">
              <span className="text-2xl" aria-hidden="true" data-id="element-23" data-mp="3m0tcnt4l0nm5">
                {line.emoji}
              </span>
              <span className="font-serif text-lg font-semibold italic text-wine" data-id="element-24" data-mp="4o8os5q90av7">{line.label}</span>
            </li>)}
        </ul>

        <div className="mt-10" data-id="element-25" data-mp="382bipdo32evs">
          <CtaButton size="lg" className="w-full max-w-xl" href={checkoutUrl} data-id="element-26" data-mp="383d4od6n0lsa">
            {ctaLabels.withPrice}
          </CtaButton>
        </div>
      </div>
    </section>;
}